

export const ENTITY_FORM_DETAILS              = 'onboarding/ENTITY_FORM_DETAILS'
export const ENTITY_FORM_DETAILS_SUCCESS      = 'onboarding/ENTITY_FORM_DETAILS_SUCCESS'
export const ENTITY_FORM_DETAILS_FAILED       = 'onboarding/ENTITY_FORM_DETAILS_FAILED'

export const GET_INVESTMENT_DETAILS             = 'onboarding/GET_INVESTMENT_DETAILS'
export const GET_INVESTMENT_DETAILS_SUCCESS     = 'onboarding/GET_INVESTMENT_DETAILS_SUCCESS'
export const GET_INVESTMENT_DETAILS_FAILED      = 'onboarding/GET_INVESTMENT_DETAILS_FAILED'
